import { getBaseUrl, getPopup } from "./common";
import Form from "./form";
import { ActionCreator, AjaxDispatcher } from "./ajax-dispatcher";
import { initCustomerDataForm } from "./main";

export class CartLoginForm {
    private form: HTMLFormElement;

    constructor(form: HTMLFormElement) {
        this.form = form;
    }

    processForm(event: Event): void {
        const url = `${getBaseUrl()}login/LoginFromCart`;
        const form = new Form(
            url,
            this.form,
            (html: string) => {
                const action = new ActionCreator().reloadComponents(['CustomerDataForm', 'Profile']);
                new AjaxDispatcher().dispatchGetAction(action);
                getPopup().close();
            },
            (html: string) => {
                document.querySelector(
                    '#login-form-outer'
                ).innerHTML = html;
            });

        form.process(event);
    }
}
